import Cookies from 'universal-cookie';
import { UsersService } from 'shared/services';
import Config from 'core/config';

const cookies = new Cookies();

const ACCESS_TOKEN = 'at';
const ID_TOKEN = 'it';
const REFRESH_TOKEN = 'rt';

const getDomainName = (hostName) => {
  return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
};

const Auth = {
  get authToken() {
    if (!this.idToken) {
      const token = cookies.get(ID_TOKEN);

      if (token) {
        this.idToken = token;
        // we got the token from cookies, don't know the expiry => refresh those tokens
        this.refreshTokens();
        return token;
      }
    }
    return this.idToken;
  },
  set authToken(token) {
    this.idToken = token;
    this.setTokenCookie(token, ID_TOKEN, this.expiration);
  },
  set accessToken(token) {
    this.aToken = token;
    this.setTokenCookie(token, ACCESS_TOKEN, this.expiration);
  },
  get accessToken() {
    if (!this.aToken) {
      const token = cookies.get(ACCESS_TOKEN);
      if (token) {
        this.aToken = token;
        return token;
      }
    }
    return this.aToken;
  },
  set refreshToken(token) {
    this.rToken = token;
    this.setTokenCookie(token, REFRESH_TOKEN);
  },
  get refreshToken() {
    if (!this.rToken) {
      const token = cookies.get(REFRESH_TOKEN);
      if (token) {
        this.rToken = token;
        return token;
      }
    }
    return this.rToken;
  },
  set expiration(time) {
    this.exp = time;
  },
  get expiration() {
    return this.exp;
  },
  set appClient(code) {
    const cookieClient = cookies.get('client');
    //if code == '', then set it to empty string
    code = cookieClient && code ? cookieClient : code;
    this.client = code;
    this.setTokenCookie(code, 'client');
  },
  get appClient() {
    if (!this.client) {
      const code = cookies.get('client');
      if (code) {
        this.client = code;
        return code;
      }
    }
    return this.client;
  },

  setAuthTokens(data) {
    let expires = 0;
    const { id_token, refresh_token, access_token, expires_in } = data;

    if (expires_in) {
      expires = new Date();
      expires.setTime(expires.getTime() + expires_in * 1000);
    }
    this.expiration = expires;
    this.authToken = id_token;
    this.accessToken = access_token;
    this.appClient = Config.APP_CLIENT;
    if (refresh_token) {
      this.refreshToken = refresh_token;
    }

    // refresh tokens 10 seconds before actual expiration
    this.setRefreshTimer(expires_in - 10);
  },

  setTokenCookie(token, tokenName, expires) {
    const secure = window.location.hostname !== 'localhost';
    const domain =
      window.location.hostname !== 'localhost'
        ? getDomainName(window.location.hostname)
        : 'localhost';
    if (token) {
      cookies.set(tokenName, token, {
        domain,
        path: '/',
        expires,
        secure,
      });
      return;
    }
    cookies.remove(tokenName, {
      path: '/',
      domain,
    });
  },

  remove() {
    this.expiration = '';
    this.authToken = '';
    this.accessToken = '';
    this.refreshToken = '';
    this.appClient = '';
    sessionStorage.clear();

    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  },

  async refreshTokens() {
    const rToken = this.refreshToken;
    const self = this;
    if (rToken) {
      UsersService.refreshTokens(rToken)
        .then(this.setAuthTokens.bind(this))
        .catch(() => {
          // refresh tokens revoked, clean up
          self.remove();
          window.location.href = window.location.origin + '/login';
        });
    } else {
      // no refresh token, clean up
      this.remove();
      window.location.href = window.location.origin + '/login';
    }
  },

  setRefreshTimer(time) {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
    this.refreshTimer = setTimeout(() => {
      this.refreshTokens();
      clearTimeout(this.refreshTimer);
    }, time * 1000);
  },

  checkTokens() {
    if (this.authToken || this.refreshToken) {
      return true;
    }
    return false;
  },
};

export default Auth;
